import React, { useEffect } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Current_User, SidebarExpandCollapseState } from '@recoil/recoil';
import PlDashboard from '@pages/dashboard/plDashboard';
import GcspDashboard from '@pages/dashboard/gcspDashboard';
import MslDashboard from '@pages/dashboard/mslDashboard';

const Dashboard = () => {
  const currentUser = useRecoilValue(Current_User);
  const [sidebarExpandState, setSidebarExpandState] = useRecoilState(SidebarExpandCollapseState);

  useEffect(() => {
    if (!sidebarExpandState) {
      setSidebarExpandState(!sidebarExpandState);
    }
  }, []);

  return (
    <>
      {' '}
      {currentUser !== null && currentUser.role === 'PL' ? <PlDashboard></PlDashboard> : null}
      {currentUser !== null && currentUser.role === 'GCSP' ? <GcspDashboard></GcspDashboard> : null}
      {currentUser !== null && currentUser.role === 'MSL' ? <MslDashboard></MslDashboard> : null}
    </>
  );
};

export default Dashboard;
